var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcVideo = function SvgIcVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "cureentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.789 10.579a2.04 2.04 0 0 0-2.22.36l-2.578 2.398v-1.739A3.598 3.598 0 0 0 18.393 8H7.598A3.598 3.598 0 0 0 4 11.598v9.595a3.598 3.598 0 0 0 3.598 3.599h10.795a3.598 3.598 0 0 0 3.598-3.599v-1.739l2.59 2.4c.382.344.878.537 1.392.539.286 0 .568-.062.828-.18A1.92 1.92 0 0 0 28 20.438v-8.084a1.918 1.918 0 0 0-1.211-1.775Z"
  })));
};
export default SvgIcVideo;